/**
 * @file 公共模块,包含Header、Footer、反馈等公共部分
 * @author fengfaxia(fengfaxia@baidu.com))
 *  Copyright (c) 2018-09-26 Baidu
 */
import React, {PureComponent} from 'react';
import {Layout} from 'antd';
import {Route, Switch} from 'react-router-dom';

import MobileLogin from '../../container/MobileLogin/index';
import Inner from '../InnerWrapper/index';

export default class Wrapper extends PureComponent {
    render() {
        return (
            <Layout>
                <Switch>
                    <Route exact path="/console/login" component={MobileLogin} />
                    <Route path="/" component = {Inner}/>
                </Switch>
            </Layout>
        );
    }
}
